<template>
  <div :class="$style.container">
    <dl :class="$style.top">
      <dt>按拼音首字母选择：</dt>
      <dd>
        <span v-for="item in list" :key="item"
          @click.stop="handleCityClick('city-'+item)"
        >{{item}}</span>
      </dd>
    </dl>

    <dl v-for="(item, idx) in cityLists" :key="item.title + idx" :class="$style.list">
      <dt :id="'city-'+item.title">{{item.title}}</dt>
      <dd>
        <span v-for="sub in item.children" :key="sub.code" @click.stop="handleSubmitCity(sub.url)" :class="sub.url ? $style.click : $style.noClick">{{sub.name}}</span>
      </dd>
    </dl>
  </div>
</template>
<script>
import pinyin  from 'js-pinyin'
export default {
  data() {
    return {
      list:'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''),
      cityLists: []
    };
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      try {
        let res = await this.$api.get2(`${this.lee}/sys/sourceRegion/v1/getSourceRegionListByThree?`)
        let arr = res.data.map(item => {
          let obj = {}
          obj.name = item.szregionalname
          obj.code = item.iregionalid
          obj.url = item.domainurl
          obj.pinyin = pinyin.getFullChars(item.szregionalname).toLocaleUpperCase().substr(0,1)
          return obj
        }).sort((a,b) => a.pinyin.charCodeAt(0) - b.pinyin.charCodeAt(0))
        let obj = {}
        for (let i = 0; i< arr.length; i++) {
          let item = arr[i]
          if (!obj[item.pinyin]) {
            obj[item.pinyin] = []
          }
          obj[item.pinyin].push(item)
        }

        let list = []
        for (let key in obj) {
          list.push({
            title: key,
            children:obj[key]
          })
        }
        this.cityLists = list
      } catch(err) {
        console.log('111:',err)
      }
    },
    // 根据字母跳转到对应的城市列表
    handleCityClick (id) {
      let dom = document.getElementById(id)
      if (dom && dom.offsetTop) {
        document.documentElement.scrollTop = dom.offsetTop +120
      }
    },
    handleSubmitCity (url) {
      if (!url) {
        return false;
      }
      window.location.href = url
    }
   
  }
};
</script> 
<style lang="less" module>
.container {
  padding-top: 20px;
  padding-left: 10px;
  border-top: 1px solid #E5E5E5;
  .top {
    &:after {
      display: block;
      content: ' ';
      overflow: hidden;
      clear: both;
    }
    dt {
      padding-bottom: 10px;
      float:left;
      font-size: 16px;
      color: #333;
      font-weight: 500;
      vertical-align: top;
      display: inline-block;
    }
    dd {
      span {
        font-size: 15px;
        color: #666;
        display: inline-block;
        margin: 0 10px;
        width: 25px;
        height: 25px;
        padding-top: 2px;
        cursor: pointer;
        box-sizing: border-box;
        text-align: center;
        border-radius: 50%;
        &:hover {
          background: #F8F8F8;
        }
      }
    }
  }
  .list {
    padding: 13px 30px 13px 10px;
    border-radius: 10px;
    &:after {
      display: block;
      content: ' ';
      overflow: hidden;
      clear: both;
    }
    dt {
      float:left;
      box-sizing: border-box;
      vertical-align: top;
      padding-top: 10px;
      display: inline-block;
      text-align: center;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      color: #fff;
      background: #4E81F0;
      box-shadow: 0 4px 5px 0 rgba(78,129,240,.22);
    }
    dd {
      overflow: hidden;
      span {
        margin: 10px 20px;
        color: #666;
        display: inline-block;
        font-size: 14px;
        cursor: pointer;
      }
    }
    .click {
      color:#000;
    }
    .noClick {
      color:#999;
    }
  }
}
</style>